"use client";

import { useForm } from "react-hook-form";
import toast, { Toaster } from "react-hot-toast";
import emailjs from "emailjs-com"; // install: npm install emailjs-com

const serviceOptions = [
  "Architecture Consultation",
  "Interior Design & Vastu Consultation",
  "Turnkey Execution",
  "Landscape Design",
  "Lighting Design",
  "Furniture Design",
];

const your_service_id =  process.env.NEXT_PUBLIC_EMAILJS_SERVICE_ID;
const your_template_id = process.env.NEXT_PUBLIC_EMAILJS_TEMPLATE_ID;
const your_public_key = process.env.NEXT_PUBLIC_EMAILJS_USER_ID;
export default function ContactForm() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    if (data.email2) {
      console.warn("Spam submission blocked.");
      return;
    }

    try {
      await emailjs.send(
        your_service_id,   // Replace with EmailJS Service ID
        your_template_id,  // Replace with EmailJS Template ID
        {
          name: data.name,
          place: data.place,
          phone: data.phone,
          service: data.service,
          priceDetails: data.priceDetails,
          message: data.message || "No message",
        },
        your_public_key    // Replace with EmailJS Public Key
      );

      toast.success("Inquiry submitted successfully!");
      reset();
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit. Please try again.");
    }
  };

  return (
    <>
      <Toaster position="top-right" />
      <section className="w-full px-4 py-10 min-h-screen flex items-center">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="w-full max-w-md mx-auto bg-white shadow-md rounded-md p-5 sm:p-6 space-y-5"
        >
          <h2 className="text-xl sm:text-2xl font-semibold text-[#A65D5D] text-center">
            Start Your Dream Space Today
          </h2>
          <p className="text-center text-gray-600 text-sm sm:text-base">
            Fill out the form and we’ll get in touch with a personalized consultation.
          </p>

          {/* Honeypot */}
          <input
            type="text"
            className="hidden"
            autoComplete="off"
            tabIndex="-1"
            {...register("email2")}
          />

          {/* Name */}
          <div>
            <label htmlFor="name" className="block text-sm font-medium mb-1">
              Name *
            </label>
            <input
              id="name"
              type="text"
              placeholder="Your full name"
              className={`w-full border p-2 rounded-md text-sm sm:text-base ${
                errors.name ? "border-red-500" : "border-gray-300"
              }`}
              {...register("name", { required: "Name is required." })}
            />
            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name.message}</p>}
          </div>

          {/* Place */}
          <div>
            <label htmlFor="place" className="block text-sm font-medium mb-1">
              Place *
            </label>
            <input
              id="place"
              type="text"
              placeholder="Your location"
              className={`w-full border p-2 rounded-md text-sm sm:text-base ${
                errors.place ? "border-red-500" : "border-gray-300"
              }`}
              {...register("place", { required: "Place is required." })}
            />
            {errors.place && <p className="text-red-500 text-xs mt-1">{errors.place.message}</p>}
          </div>

          {/* Phone */}
          <div>
            <label htmlFor="phone" className="block text-sm font-medium mb-1">
              Phone Number *
            </label>
            <input
              id="phone"
              type="tel"
              placeholder="1234567890"
              className={`w-full border p-2 rounded-md text-sm sm:text-base ${
                errors.phone ? "border-red-500" : "border-gray-300"
              }`}
              {...register("phone", {
                required: "Phone number is required.",
                pattern: {
                  value: /^\d{10}$/,
                  message: "Phone number must be exactly 10 digits.",
                },
              })}
            />
            {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone.message}</p>}
          </div>

          {/* Service */}
          <div>
            <label htmlFor="service" className="block text-sm font-medium mb-1">
              Select Service *
            </label>
            <select
              id="service"
              defaultValue=""
              className={`w-full border p-2 rounded-md text-sm sm:text-base ${
                errors.service ? "border-red-500" : "border-gray-300"
              }`}
              {...register("service", { required: "Please select a service." })}
            >
              <option value="" disabled>
                Choose a service
              </option>
              {serviceOptions.map((service) => (
                <option key={service} value={service}>
                  {service}
                </option>
              ))}
            </select>
            {errors.service && (
              <p className="text-red-500 text-xs mt-1">{errors.service.message}</p>
            )}
          </div>

          {/* Price Details */}
          {/* <div>
            <label htmlFor="priceDetails" className="block text-sm font-medium mb-1">
              Price Details *
            </label>
            <input
              id="priceDetails"
              type="text"
              placeholder="₹10,000 - 50,000"
              className={`w-full border p-2 rounded-md text-sm sm:text-base ${
                errors.priceDetails ? "border-red-500" : "border-gray-300"
              }`}
              {...register("priceDetails", {
                required: "Price details are required.",
              })}
            />
            {errors.priceDetails && (
              <p className="text-red-500 text-xs mt-1">{errors.priceDetails.message}</p>
            )}
          </div> */}

          {/* Message */}
          <div>
            <label htmlFor="message" className="block text-sm font-medium mb-1">
              Message (optional)
            </label>
            <textarea
              id="message"
              placeholder="Additional details or questions"
              className="w-full border border-gray-300 p-2 rounded-md text-sm sm:text-base resize-y min-h-[100px]"
              {...register("message")}
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-[#A65D5D] text-white py-3 rounded-md font-semibold hover:bg-[#8C4A4A] transition text-sm sm:text-base"
          >
            {isSubmitting ? "Submitting..." : "Submit Inquiry"}
          </button>
        </form>
      </section>
    </>
  );
}
